import { FC, memo } from 'react';
import ReactPlayer from 'react-player';
import { ReactComponent as Play } from 'images/newIcons/play.svg';

interface MediaPlayerProps {
  url: string;
  width?: number | string;
  height?: number | string;
}

const MediaPlayer: FC<MediaPlayerProps> = ({
  url,
  width = 750,
  height = '100%',
}) => (
  <ReactPlayer
    width={width}
    height={height}
    url={url}
    playing={false}
    controls
    light
    playIcon={<Play />}
  />
);

export default memo(MediaPlayer);
